import React from "react";
import "./Settings.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

function Settings() {
  return (
    <>
      <Header />
      <section className="stats-rankings">
        <div className="exploreCollections">
          <div className="container">
            <div className="section-title">
              <h2>SETTINGS</h2>
            </div>
            <div className="settings-wrap">
              <div className="settings-wrap__left">
                <h4>Notification Settings</h4>
                <p className="txt">
                  Select which notifications you would like to receive.
                </p>
                <ul className="settings-list">
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check1" />
                      <label for="check1">
                        Item Sold{" "}
                        <span>When someone purchased oone of your items</span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check2" />
                      <label for="check2">
                        Bid Activity{" "}
                        <span>When someone bids on one of your items</span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check3" />
                      <label for="check3">
                        Price Change{" "}
                        <span>
                          When an item you made an offer on changes in price
                        </span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check4" />
                      <label for="check4">
                        Auction Expiration
                        <span>When a timed auction you created ends</span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check5" />
                      <label for="check5">
                        Outbid
                        <span>
                          When an offer you placed is exceeded by another user
                        </span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check6" />
                      <label for="check6">
                        Owned Item Updates
                        <span>
                          When a significant update occurs for one of the items
                          you have purchased on RedShilliz
                        </span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check7" />
                      <label for="check7">
                        Successful Purchase
                        <span>When you successfully buy an item</span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox">
                      <input type="checkbox" id="check8" />
                      <label for="check8">
                        RedShilliz Newsletter
                        <span>Occasional updates from the RedShilliz team</span>
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="settings-wrap__right">
                <h4>Minimum Bid Threshold</h4>
                <p className="txt">
                  Receive notifications only when you receive offers with a
                  value greater than or equal t this amount of ETH.
                </p>
                <div className="form-group">
                  <div className="form-control__wrapp">
                    <span>
                      <img src="../images/eth.png" alt="Coin" /> ETH
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="0.005"
                    />
                  </div>
                </div>
                <h4>Account Support</h4>
                <p className="txt">
                  If you believe your account has been compromised, let us know
                  and we can lock your account. This will disable items in your
                  wallet from being bought, sold, or transferred using
                  RedShilliz. <a href="/#">Learn more</a>.
                </p>
                <a href="/#" className="button red-outline">
                  Lock Account
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Settings;
